<template>
  <div id="main-content" class="authorized-person-notification-detail">
    <el-col :offset="1" :span="22">
      <PageTitle :title="title" :backLink="backLink"></PageTitle>
      <template v-if="notificationDetail">
        <el-row>
          <el-col :span="24">
            <span class="form-lable">{{ $t('common.parent_name') }}:</span>
            <span class="info-span">
              {{ notificationDetail.parent_name }}
            </span>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="24">
            <span class="form-lable">{{ $t('authorized_person_notification.student_name') }}:</span>
            <span class="info-span">
              {{ notificationDetail.student_name }}
            </span>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="24">
            <span class="form-lable">{{ $t('authorized_person_notification.type') }}:</span>
            <span class="info-span">{{ getType(notificationDetail.type) }}</span>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="24">
            <span class="form-lable">{{ $t('authorized_person_notification.date') }}:</span>
            <span class="info-span">{{ getDate(notificationDetail) }}</span>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="24">
            <span class="form-lable">{{ $t('authorized_person_notification.person_name') }}:</span>
            <span class="info-span">{{ notificationDetail.person_name }}</span>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="24">
            <span class="form-lable">{{ $t('authorized_person_notification.person_phone') }}:</span>
            <span class="info-span">{{ notificationDetail.person_phone }}</span>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="24">
            <span class="form-lable">{{ $t('moreLanguage.createdAt') }}:</span>
            <span class="info-span">{{ $moment(notificationDetail.created_at).format('YYYY-MM-DD') }}</span>
          </el-col>
        </el-row>

      </template>
    </el-col>
  </div>
</template>

<script>
  import { ITEM_PER_PAGE, GENDER_FEMALE, AUTHORIZED_PERSON_TYPE_DATE, AUTHORIZED_PERSON_TYPE_RANGE } from '@/config'
  import PageTitle from '@/components/PageTitle'

  export default {
    name: 'AuthorizedPersonNotificationDetail',
    components: {
      PageTitle
    },
    data: function () {
      return {
        backLink: `/notification/authorized-person?action=back`,
        title: 'authorized_person_notification.detail_title',
        notificationDetail: null
      }
    },
    methods: {
      getType (type) {
        switch (type) {
          case AUTHORIZED_PERSON_TYPE_DATE:
            return this.$t('authorized_person_notification.date_type')
          case AUTHORIZED_PERSON_TYPE_RANGE:
            return this.$t('authorized_person_notification.range_type')
          default:
            return ''
        }
      },
      getDate(notification) {
        switch (notification.type) {
          case AUTHORIZED_PERSON_TYPE_DATE:
            return this.$moment(notification.date).format('YYYY-MM-DD')
          case AUTHORIZED_PERSON_TYPE_RANGE:
            return `${this.$moment(notification.start_date).format('YYYY-MM-DD')} ~ ${this.$moment(notification.end_date).format('YYYY-MM-DD')}`
          default:
            return ''
        }
      }
    },
    mounted: function () {
      let successCallback = (response) => {
        this.notificationDetail = Object.assign({}, response.data.data.notification_info)
      }

      let payload = {
        successCallback,
        id: this.$route.query.id
      }

      this.$store.dispatch('notification/retrieveAuthorizedPersonNotificationDetail', payload)
    }
  }
</script>
<style lang="scss">
  .parent-upload-history-detail {
    img {
      display: block;
      max-width: 200px;
      margin: 0 auto;
    }

    td, th {
      padding: 10px;
    }
  }

</style>
